module.exports = __webpack_public_path__ + "2346c7b144397a552b080dae00156e5c.pdf";